import { useEffect, useState, useCallback } from "react";

const Toast = ({
  show,
  message,
  type = "success",
  onClose,
  duration = 3000,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = useCallback(() => {
    setIsClosing(true);
    // 애니메이션 시간만큼 기다린 후 실제로 닫기
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300); // 애니메이션 시간과 동일
  }, [onClose]);

  useEffect(() => {
    if (show) {
      setIsClosing(false); // show될 때 isClosing 초기화
      const timer = setTimeout(() => {
        setIsClosing(true);
        // 애니메이션 시간만큼 기다린 후 실제로 닫기
        setTimeout(() => {
          onClose();
          setIsClosing(false);
        }, 300);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!show) return null;

  const getToastStyle = () => {
    const baseStyle = {
      position: "fixed",
      top: "20px",
      right: "20px",
      padding: "16px 20px",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      gap: "12px",
      fontSize: "14px",
      fontWeight: "500",
      minWidth: "300px",
      maxWidth: "500px",
      animation: isClosing
        ? "slideOutRight 0.3s ease-in"
        : "slideInRight 0.3s ease-out",
    };

    switch (type) {
      case "success":
        return {
          ...baseStyle,
          backgroundColor: "#10B981",
          color: "white",
        };
      case "error":
        return {
          ...baseStyle,
          backgroundColor: "#EF4444",
          color: "white",
        };
      case "info":
        return {
          ...baseStyle,
          backgroundColor: "#3B82F6",
          color: "white",
        };
      default:
        return {
          ...baseStyle,
          backgroundColor: "#10B981",
          color: "white",
        };
    }
  };

  const getIcon = () => {
    switch (type) {
      case "success":
        return "✅";
      case "error":
        return "❌";
      case "info":
        return "ℹ️";
      default:
        return "✅";
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes slideInRight {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          @keyframes slideOutRight {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(100%);
              opacity: 0;
            }
          }
        `}
      </style>
      <div style={getToastStyle()}>
        <span style={{ fontSize: "16px" }}>{getIcon()}</span>
        <span style={{ flex: 1 }}>{message}</span>
        <button
          onClick={handleClose}
          style={{
            background: "none",
            border: "none",
            color: "white",
            fontSize: "18px",
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            opacity: 0.8,
            transition: "opacity 0.2s",
          }}
          onMouseEnter={(e) => {
            e.target.style.opacity = "1";
          }}
          onMouseLeave={(e) => {
            e.target.style.opacity = "0.8";
          }}
        >
          ✕
        </button>
      </div>
    </>
  );
};

export default Toast;
